import { useState } from "react";
import { Form } from "react-bootstrap";
import SntSearchIcon from "@icons/SntSearchIcon";
import { useDebouncedEffect } from "../../../hooks/useDebouncedEffect";

function SearchInput({ onChange, setShowSearchPanel, id, language }) {
  const [query, setQuery] = useState(null);
  useDebouncedEffect(() => onChange && onChange(query), 200, [query]);
  return (
    <>
      <Form.Control
        placeholder={language.input_search_key}
        autoComplete="off"
        onFocus={() => setShowSearchPanel && setShowSearchPanel(true)}
        onChange={(e) => {
          setQuery(e.target.value);
        }}
        id={id}
        style={{ position: "relative", paddingLeft: 35 }}
      />

      <SntSearchIcon
        style={{ position: "absolute", top: 10, left: 10, color: "#999" }}
      />
    </>
  );
}

SearchInput.propTypes = {};

export default SearchInput;
